import { render, staticRenderFns } from "./Gb.vue?vue&type=template&id=1c203b3c"
import script from "./Gb.vue?vue&type=script&lang=js"
export * from "./Gb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports